import React from 'react';
import AllOverlaysTabContent from '../AllOverlaysTabContent'

const MainOverlaysTabContent = (props) => {
  return (
    <AllOverlaysTabContent />
  );
};

export default MainOverlaysTabContent
